import client from "./client";

export interface Cover {
  id: number;
  userId: number;
  templateId: number;
  authorName: string;
  receiverName: string;
  bookTitle: string;
  coverUrl: string;
}

export const coversApi = {
  get: (templateId: number) =>
    client.get<Cover>(`/covers/${templateId}`),

  upsert: (data: {
    templateId: number;
    authorName: string;
    receiverName?: string;
    bookTitle: string;
    coverUrl?: string;
  }) => client.post<Cover>("/covers", data),
};
